<app-nav-context-header [expanded]="expanded()" [backRoute]="contactsListRoute()" backLabel="HEADER.ALL_CONTACTS"
    [title]="headerTitle()" [loading]="headerLoading()" />

<ul class="yllw-sidenav__menu">
    <li class="yllw-sidenav__item">
        <a class="yllw-sidenav__item-link" [routerLink]="overviewRoute()" routerLinkActive="yllw-sidenav__item-link--active"
            [routerLinkActiveOptions]="{ paths: 'exact', matrixParams: 'ignored', queryParams: 'ignored', fragment: 'ignored' }" pRipple
            [pTooltip]="'CONTACT.TABS.OVERVIEW' | translate" tooltipPosition="right" [tooltipDisabled]="expanded()">
            <i class="pi pi-th-large yllw-sidenav__item-icon"></i>
            @if (expanded()) { <span class="yllw-sidenav__item-text">{{ "CONTACT.TABS.OVERVIEW" | translate }}</span> }
        </a>
    </li>
</ul>
